





































    import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
    import TableField from '@/types/TableField';
    import { BTable, BButton, BFormGroup, BCol, BRow, BCard, BSpinner } from 'bootstrap-vue';
    import InlineSvg from 'vue-inline-svg';

    @Component({
        components: {
            'b-table': BTable,
            'b-card': BCard,
            'b-btn': BButton,
            'b-row': BRow,
            'b-col': BCol,
            'b-form-group': BFormGroup,
            'inline-svg': InlineSvg,
            'b-spinner': BSpinner
        }
    })
	export default class TaskUserList extends Vue {
        @Prop() canEdit!: boolean;
        @Prop() users!: TaskUserListItem[];

        isBusy = false;
        localUsers: TaskUserListItem[] = [];

        fields: TableField[] = [
			{
                key: 'name',
                label: 'fields.user',
                headerTitle: 'Name',
                sortable: true,
                thStyle: '',
                thClass: 'unselectable text-nowrap',
                tdClass: 'text-nowrap',
                formatter: null
            },
            {
                key: 'actions',
                label: '',
                headerTitle: '',
                sortable: false,
                thStyle: 'width: 100px',
                thClass: '',
                tdClass: 'text-right pl-3 pr-1',
                formatter: null
            }
        ];

        @Watch('users')
        getLocalUsers(newVal: TaskUserListItem[]) {
            if (this.localUsers.length === 0) {
                this.localUsers = newVal;
            }
        }

        mounted() {
            this.isBusy = false;
        }

        deleteUser(id: string) {
            this.$bvModal.msgBoxConfirm(this.$t('modal.confirmTaskUserDeleteMessage') as string, {
                title: this.$t('modal.confirmTaskUserDeleteTitle') as string,
                centered: true,
                buttonSize: 'sm',
                okTitle: this.$t('modal.confirmOkTitle') as string,
                cancelTitle: this.$t('modal.confirmCancelTitle') as string
            })
            .then(value => {
                if (value) {
                    this.localUsers.splice(this.localUsers.findIndex(lu => lu.id === id), 1);
                }
            })
            .catch(error => {
                console.error(error);
            });
        }
	}

    interface TaskUserListItem {
        id: string;
        name: string;
        actions: string;
    }
